/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { HistoryInfoHistoryCategory } from './historyInfoHistoryCategory';


export interface HistoryInfo { 
    archived?: boolean;
    createdAt?: string;
    description?: string;
    embed?: string;
    historyCategory?: HistoryInfoHistoryCategory;
    historyCategoryId?: number;
    historyId?: number;
    id?: string;
    image?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    linkText?: string;
    locked?: boolean;
    pdf?: string;
    published?: boolean;
    readOnly?: boolean;
    sortOrder?: number;
    story?: string;
    title?: string;
    updatedAt?: string;
    version?: number;
}
